<template>
  <div>
    <v-navigation-drawer
      app
      v-model="drawerOpen"
      clipped
      flat
      class="color"
      mobile-breakpoint="xs"
      :style="style"
      :width="width"
      hide-overlay
      ><slot></slot>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'SideNavigationContainer',
  data: () =>{
    return {
      drawerOpen: false,
    };
  },

  methods:{
    toggleDrawerOpen(){
      this.drawerOpen = !this.drawerOpen;
    },
  },
  created() {
    this.drawerOpen = !this.$vuetify.breakpoint.xs;
  },

  computed: {
    width(){
      if (this.$vuetify.breakpoint.xs){
        return '100%';
      }
      return undefined;
    },
    style(){
      if (this.$vuetify.breakpoint.xs){
        return `margin-top: ${this.$vuetify.application.top}px`;
      }
      return undefined;
    },
  },
};
</script>
